<div class="body">
    <br/>
    <div class = "container principal">
        <div class = "col-lg-12"> 
          <p>Circular N° 3623 de fecha 18.10.2021, Superintendencia de Seguridad Social. <b>Los afiliados deben conservar los originales de los documentos </b>
           <br/>
           <b>de respaldo de los beneficios solicitados digitalmente al Servicio de Bienestar, por el plazo de 5 años</b>
           <br/>
           <b> conforme a los Artículos N° 2514 y 2515 del Código Civil.</b>  Dictamen N° 467/2021. 
           <br/>  
           <br/>   
           La adulteración de datos y/o documentos contables constituye una falta grave a la probidad lo cual 
           <br/>
           conlleva expulsión total del Servicio de Bienestar y el inicio inmediato de una investigación o sumario  administrativo.   
          <br/>  
          </p>  

          <p><b>Manual de subsidio de nacimiento: </b> <a href="{{this.linkTexto}}" target="_blank">
            Nacimiento</a>.</p>     
        </div>
    </div>
    <br />
    <div class="row">

        <div class="col-lg-5"> </div>

        <div class="center">
            <h1> Subsidio Nacimiento </h1>
        </div>

        <div class="col-lg-4"> </div>

    </div>
    <br />

    <form #nacimientoForm=ngForm>

        <div class="container principal">
            <div *ngIf="rol == 'ROLE_AFILIADO' || rol == 'ROLE_JUBILADO'">

                <div class="row">

                    <div class="col-lg-8"> </div>

                    <div class="col-lg-4">
                        <p> <b> Usuario: </b> {{nombreUsuario}} </p>
                    </div>

                </div>

            </div>

            <div *ngIf="rol != 'ROLE_AFILIADO'" style="padding-bottom: 20px;">
                <div class="row line">

                    <div class="col-lg-2"> </div>

                    <div class="col-lg-2">
                        <h2> Rut Afiliado </h2>
                    </div>

                    <div class="col-lg-4">

                        <input id="rutAfiliado" name="rutAfiliado" [(ngModel)]="buscador.rutAfiliado"
                            #rutAfiliado="ngModel" class="form-control" type="text" required
                            placeholder="Ingrese el RUT del afiliado. Ej: 11111111-1"
                            pattern="[0-9.]{7,10}[-]{1}[0-9Kk]{1}" />

                    </div>

                    <div class="col-lg-4">

                        <button class="btn btn-primary" id="btnvalida"
                            (click)="buscaHijoRegistroCivil(buscador.rutAfiliado,3)" [disabled]="rutAfiliado.invalid">

                            Buscar

                        </button>

                    </div>
                </div>

                <div class="row line">

                    <div class="col-lg-4"> </div>
                    <div class="col-lg-5">
                        <h2>{{this.afiliado.nombreAfiliado}} {{this.afiliado.rutAfiliado}}
                        </h2>

                    </div>
                </div>
            </div>

            <div class="row">

                <div class="col-lg-1"> </div>

                <div class="col-lg-4">
                    <h1> Subsidio Nacimiento </h1>
                </div>

                <div class="col-lg-4"> </div>

            </div>

            <hr /> <br />


            <div class="row">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Tipo Nacimiento </p>
                </div>


                <div class="col-lg-5">


                    <mat-select class="form-control" name="tipoNacimiento" #tipoNacimiento="ngModel"
                    (selectionChange)="inhabilitarPorTipo()"  [(ngModel)]="nacimiento.tipoNacimiento" required>

                        <mat-option value="0">
                            SELECCIONE....
                        </mat-option>
                        <mat-option *ngFor="let tipo of this.tipos" value="{{tipo.id}}">
                            {{tipo.descripcion}}
                        </mat-option>
                    </mat-select>

                </div>

                <div class="col-lg-3"> </div>

            </div>

            <br />
            <div class="row">
                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <label> RUT Hijo </label>
                </div>
                <div class="col-lg-5">

                    <input id="rutHijo" name="rutHijo" [(ngModel)]="nacimiento.rutHijo" #rutHijo="ngModel"
                        class="form-control" type="text" required type="text" value="15314204-1"
                        placeholder="Ingrese el RUT del prestador. Ej: 11111111-1"
                        pattern="[0-9]{7,10}[-]{1}[0-9Kk]{1}" />

                </div>
                <div class="col-lg-3">
                    <button class="btn btn-info" (click)="buscarHijo(nacimiento.rutHijo)">
                        Consultar
                    </button>
                </div>
            </div>    
            <br />
            <div class="row">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3"> <label> Nombre Completo </label> </div>

                <div class="col-lg-5">

                    <input id="nombres" name="nombres" #nombres="ngModel" [(ngModel)]="nacimiento.nombres"
                        class="form-control" [disabled] = "nacimiento.nomNacDeshabilitado" required type="text" />


                </div>
                <div class="col-lg-3"> </div>
            </div>
            <br />

            <div class="row ">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Fecha Nacimiento </p>
                </div>

                <div class="col-lg-5">

                    <input class="form-control" id="fechaNacimiento" name="fechaNacimiento" #fechaNacimiento="ngModel"
                        [(ngModel)]="nacimiento.fechaNacimiento" [disabled] = "nacimiento.fechaNacDeshabilitado" required type="date">

                </div>

                <div class="col-lg-3"> </div>

            </div>
            <br />
            <div class="row ">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Fecha Adopción / Tuición </p>
                </div>

                <div class="col-lg-5">

                    <input class="form-control" name="fechaAdopcion" #fechaAdopcion="ngModel"
                    [disabled] = "nacimiento.fechaAdopcionDeshabilitado"   [(ngModel)]="nacimiento.fechaAdopcion" type="date">

                </div>

                <div class="col-lg-3"> </div>

            </div>
            <br />
            <div class="row">
              
                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Adjuntar </p>
                </div>
    
                <div class="col-lg-5">
    
                    <input type="file" class="form-control-file" name="archivo" required
                        accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="nacimiento.archivoTest"
                        (change)="seleccionaArchivo($event, 0)">
    
                </div>
    
                <div class="col-lg-1"> </div>
    
                <div class="col-lg-1">  </div>
    
                <div class="col-lg-1"> </div>
                

            </div>


            <br />
            <div class="row">

                <div class="col-lg-2 col-sm-2"> </div>

                <div class="col-lg-6 col-sm-1"> </div>

                <div class="col-lg-3 col-sm-1">
                    <!--<div *ngIf="rol != 'ROLE_EJECUTIVO_CAIP'"> -->
                    <div *ngIf="rol != 'ROLE_EJECUTIVO_CAIP' && rol != 'ROLE_CONTABILIDAD' && rol != 'ROLE_ENCARGADO_CONTABILIDAD'">
                        <button class="btn btn-success " (click)="solicitar(nacimientoForm)">
                            Solicitar
                        </button>
                    </div>
                </div>

                <div class="col-lg-1 col-sm-1"> </div>

            </div>



        </div>
    </form>
  
</div>